// /**
//  * Orders - list
//  */

// React
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WrapperReceipt } from './style';
import {
  getOrdersAction,
} from '../../orders/actions';
// Context
import AuthContext from '../../../authContext';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from '@material-ui/core';

// Components
import Can from '../../../components/Can';
import { useParams } from 'react-router-dom';

import jMoment from 'moment-jalaali';

type Data = Order;
type Props = {
  data: any;
  users: object;
  loading: boolean;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
      width: '100%',
      height: '100%',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: '4px',
      overflow: 'visible',
      justifyContent: 'center'
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);



function EnhancedTableHead(props: EnhancedTableProps) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const {
    order,
    rowCount,
  } = props;

  let headCells: HeadCell[] = [];

  Can({
    role: authContext.user.role,
    perform: 'orders:list:centerName',
    yes: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'ردیف',
        },
        { id: 'id', label: 'شماره فاکتور' },
        { id: 'partnerName', label: 'شرکت' },
        { id: 'centerName', label: 'نام مشتری' },
        {
          id: 'deliveryDate',
          label: 'شماره تماس',
        },
        { id: 'status', label: 'آدرس' },
        { id: '5', label: 'زمان تحویل' },
        { id: '4', label: 'محل امضاء تحویل گیرنده' },
      ];
    },
    no: () => {
      headCells = [
        {
          id: '1',
          label: 'ردیف',
        },
        { id: 'id', label: 'شماره فاکتور' },
        { id: 'packages', label: 'تعداد بسته' },
        { id: 'partnerName', label: 'شرکت' },
        { id: 'centerName', label: 'نام مشتری' },
        {
          id: 'deliveryDate',
          label: 'شماره تماس',
        },
        { id: 'status', label: 'آدرس' },
        { id: '5', label: 'زمان تحویل' },
        { id: '4', label: 'محل امضاء تحویل گیرنده' },
      ];
    },
  });

  // @ts-ignore

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            data-cy={headCell.id}
            style={{ fontSize: '10px', width: '10px', }}
          >
            <span className={classes.columnText}>{headCell.label}</span>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const dispatch = useDispatch();
  const ordersStore = useSelector(state => state.orders);
  const { id } = useParams();
  function pad(d) {
    return d < 10 ? '0' + d.toString() : d.toString();
  }
  useEffect(() => {
    if (id) {
      dispatch(getOrdersAction({ 'bundleId.equals': id, page: 0, size: 1000 }));
    }
  }, []);
  useEffect(() => {
    if (ordersStore.ordersList.length) {
      window.print();
    }
  }, [ordersStore]);
  const getDate = () => {
    const date = new Date();
    const year = date.getFullYear().toString();
    const day = pad((date.getDate()).toString());
    const month = pad((date.getMonth() + 1).toString());
    const fullDate = year + '-' + month + '-' + day;
    return fullDate;
  }

  return (
    <WrapperReceipt className={classes.root}>
      <div className="page">
        <div className="logo-box">
          <div>
            <span>
              {jMoment(getDate(), 'YYYY/M/D').locale('fa').format('jYY/jMM/jDD')}
            </span>
          </div>
          <h1>
            رسید تحویل سفارشات مشتریان
          </h1>
          <div>
            <img src="/logo-dark.svg" alt="logo" />
          </div>
        </div>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            // size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
            style={{
              textAlign: 'center',
              alignItems: 'center',
              display: 'relative',
            }}
          >
            <EnhancedTableHead
              classes={classes}
              order={ordersStore.ordersList}
              rowCount={ordersStore.ordersList.length}
            />
            <TableBody>
              {ordersStore.ordersList.map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    key={index}
                    hover
                    tabIndex={-1}
                    style={{ height: "85px" }}
                  >
                    <StyledTableCell
                      align="center"
                      data-cy="row-id"
                    >
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.id}
                    </StyledTableCell>
                    <StyledTableCell
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.packages.length}
                    </StyledTableCell>
                    <StyledTableCell
                      id={labelId}
                      scope="row"
                      align="center"
                      style={{ fontSize: '10px' }}
                    >
                      {row.partnerName}
                    </StyledTableCell>
                    <StyledTableCell
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.customerName}
                    </StyledTableCell>
                    <StyledTableCell
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.customerMobileNumber}
                    </StyledTableCell>
                    <TableCell
                      id={labelId}
                      scope="row"
                      align="center"
                      style={{
                        fontSize: '14px',
                        width: '100%',
                        maxWidth: '500px'
                      }}
                    >
                      {row.customerAddress}
                    </TableCell>
                    <StyledTableCell align="center" >
                      <span>
                        {jMoment(row.deliveryDate, 'YYYY/M/D')
                          .locale('fa')
                          .format('jYY/jMM/jDD')}
                      </span>
                      &nbsp; &nbsp;- &nbsp; &nbsp;
                      <span>
                        {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                          .locale('fa')
                          .format('HH')}
                        `}
                        {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                          .locale('fa')
                          .format('HH')}`}
                      </span>
                    </StyledTableCell>
                    <StyledTableCell />
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          justify="space-around"
          style={{ position: 'fixed', bottom: '0', marginBottom: '0' }}
        >
          <Grid item>محل امضاء انباردار : </Grid>
          <Grid item>
            محل امضاء راننده ({ordersStore?.ordersList[0]?.driverName}) :{' '}
          </Grid>
          <Grid item>محل امضاء حراست : </Grid>
        </Grid>
      </div>
    </WrapperReceipt>
  );
}
